import Vue from 'vue'
import promotion from '@/common/promotion'

Vue.filter('haspromotion', function(value, name) {
  if (!value) return false
  return promotion.hasActivePromotion(name, value)
})

Vue.filter('promotiontimer', function(value, name) {
  if (!value) return null

  if (promotion.hasActivePromotion(name, value)) {
    const cdDate = promotion.getEndDateForPromotion(name, value)
    if (cdDate) {
      this.dealEndtime = cdDate - new Date()
    }
  }
  return null
})

Vue.filter('hasanypromotion', function(value) {
  //exclude offers with insurance an no other promotion
  if (
    promotion.count(value) == 1 &&
    promotion.hasActivePromotion('InsuranceIncluded', value)
  ) {
    return false
  }

  return promotion.hasAnyPromotion(value)
})

// Vue.filter('hasinsuranceonly', function(value) {
//   return (
//     promotion.count(value) == 1 &&
//     promotion.hasActivePromotion('InsuranceIncluded', value)
//   )
// })
